import { useNavigate } from "react-router-dom";
import MyButton from "components/ui/Button/MyButton";
import { ReactComponent as NetworkTowerIcon } from "../assets/svg/network.svg";
import { message } from "antd"; // Import Ant Design message notification

const NetworkError = () => {
    const navigate = useNavigate(); // Hook to navigate between pages

    const handleRetry = () => {
        if (navigator.onLine) {
            navigate('/home'); 
        } else {
            message.error("Still offline! Please check your internet connection.");
        }
    };

    return (
        <div className="flex flex-col justify-center items-center h-[100vh] bg-white gap-2 text-center">
            {/* <img src={networkTower} alt="networkTower" className="-mt-3" /> ---> this line is commented 
            because svg image is won't load when no internet is available and svg are always refetch from internet 
            but if we add image as react component svg image can be mount without internet  */} 
            <NetworkTowerIcon className="-mt-3" />
            <div className="text-lg text-red-500 font-bold">No Internet Found!</div>
            <div className="text-sm text-gray-500">
                Oops! It seems you're offline. Please check your internet <br /> 
                connection and try again.
            </div>

            <MyButton label="Retry" onClick={handleRetry} />

            <p className="text-center">
                If the issue persists, contact our support team <br />
                at <a href="mailto:support@hrbuddie.com?subject=Support Request&body=Hi Team, I need help with..." 
                className="text-[#04B7B1] hover:text-[#04B7B1]">
                    support@hrbuddie.com
                </a>
            </p>
        </div>
    );
};

export default NetworkError;
